@if (!hasAuthenticated() || !showDashboard()) {
  <router-outlet />
} @else {
  <app-layout>
    <router-outlet />
  </app-layout>

  <!-- <app-consent-banner -->
  <!--   (bannerHeight)="onBannerHeightChange($event)" -->
  <!--   analyticId="C7SBC782L6" -->
  <!--   [buildConfig]="BUILD_CONFIG" -->
  <!-- /> -->
}
@if (!isAdmin()) {
  <div class="hidden">
    <ui-nav-menu>
      <a href="/dashboard" rel="home">{{ 'breadcrumb.dashboard' | translate }}</a>
      @for (sidebarItem of sidebarItems(); track sidebarItem.name) {
        <a [href]="'/' + sidebarItem.href.slice(1).join('/')">
          {{ sidebarItem.name }}
        </a>
      }
    </ui-nav-menu>
  </div>
}

<app-theme-extension-banner />

<ng-template #ctaButtonTemplate>
  <div class="flex space-x-2">
    <button mat-flat-button id="create-chart-btn" (click)="onNavigateToDashboard()">
      {{ 'cta.create-a-chart' | translate }}
    </button>
  </div>
</ng-template>

<!-- <ng-template #planUsageIndicatorTemplate> -->
<!--   <app-plan-usage-indicator /> -->
<!-- </ng-template> -->

<ng-template #aiSizeRecommendationUsageLimitRef>
  <div class="flex flex-col">
    <span class="text-sm text-brand-600">
      {{
        'banner.you-have-reached-x-of-ai-size-recommendations-limit'
          | translate: { x: (aiSizeRecommendationPerc() | number: '1.0-0') }
      }}
    </span>
  </div>
</ng-template>

<ng-template #stockNotificationUsageLimitRef>
  <div class="flex flex-col">
    <span class="text-sm text-brand-600">
      {{
        'banner.you-have-reached-x-of-stock-notification-limit'
          | translate: { x: (stockNotificationPerc() | number: '1.0-0') }
      }}
    </span>
  </div>
</ng-template>

<ng-template #overUsageCostRef>
  <div class="flex flex-col gap-1">
    <span class="text-sm text-brand-600">
      {{ 'banner.you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service' | translate }}
    </span>

    <button
      mat-flat-button
      class="!h-6 w-fit !text-xs"
      (click)="onPayOverUsageCost()"
      [disabled]="payingOverUsageCost()"
    >
      @if (payingOverUsageCost()) {
        <mat-spinner [diameter]="20" />
      } @else {
        {{ 'common.pay' | translate }}
      }
    </button>
  </div>
</ng-template>
